<mat-card *ngIf="kfRegistration">
  <div class="wizard-buttons-container align-right">
    <button mat-raised-button (click)="print()" color="primary">
      <mat-icon class="material-icons-outlined">print</mat-icon>
      <span>Print</span>
    </button>
    <button mat-raised-button (click)="printLastYear()" [disabled]="!existsPreviousYear">
      <mat-icon class="material-icons-outlined">print</mat-icon>
      <span>Last year</span>
    </button>
    <button mat-raised-button (click)="location.back()">
      <mat-icon class="material-icons-outlined">view_list</mat-icon>
      <span>Overview</span>
    </button>
  </div>
  <mat-card-title>
    <h1>
      <span class="key-figure">{{kfRegistration.keyFigures}} {{kfRegistration.year}}
        | </span><span>{{kfRegistration.countryName ? kfRegistration.countryName : kfRegistration.weeeSystemName}}</span>
    </h1>
  </mat-card-title>
  <mat-card-content>
    <form class="form-search-bar" [formGroup]="generalInfoForm">
      <mat-form-field class="full-width-input" appearance="outline" color="primary">
        <mat-label>Estimation / Determined</mat-label>
        <mat-select [formControl]="estimatedDeterminedControl">
          <mat-option value="ESTIMATION"> Estimated</mat-option>
          <mat-option value="DETERMINED"> Determined</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field class="full-width-input" appearance="outline" color="primary">
        <mat-label>B2B / B2C</mat-label>
        <mat-select [formControl]="b2bb2cControl">
          <mat-option value="UNDIFFERENTIATED"> Undifferentiated</mat-option>
          <mat-option value="DIFFERENTIATED"> Differentiated</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field class="full-width-input" appearance="outline" color="primary">
        <mat-label>B2B in your report includes (select more than one option if necessary)</mat-label>
        <mat-select [formControl]="b2bIncludesControl" multiple>
          <mat-option *ngFor="let option of b2bIncludes" [value]="option">{{option}}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-checkbox
        [checked]="kfRegistrationDetail?.kfRegistration?.noDataReport === true"
        [formControl]="confidentialControl" >
        Data is confidential and will not be reported
      </mat-checkbox>

      <mat-checkbox *ngIf="kfRegistrationDetail?.kfRegistration?.clearedWeee !== null "
                    matTooltip="If you will include WEEE in your report that has been collected by another PRO but belongs under your PRO´s obligation and you compensated them for it financially or other ways, please tick this box."
                    [checked]="kfRegistrationDetail?.kfRegistration?.clearedWeee === true"
                    [formControl]="clearedWeeeControl">
        Reported collection includes cleared WEEE
      </mat-checkbox>

      <mat-form-field class="full-width-input" appearance="outline" color="primary">
        <mat-label>Notes</mat-label>
        <textarea [formControl]="notesControl" matInput>Notes</textarea>
      </mat-form-field>
      <div class="info-checkers">
        <mat-checkbox *ngIf="kfRegistrationDetail?.kfRegistration?.completionStatus" disabled [checked]="true">
          Completed by member
        </mat-checkbox>
        <mat-checkbox *ngIf="kfRegistrationDetail?.kfRegistration?.validationStatus" disabled [checked]="true">
          Validated by WEEE-Forum
        </mat-checkbox>
      </div>
    </form>
    <div class="entries-container">
      <h3>Entries</h3>
      <app-kf-registration-validation-table *ngIf="keyFigures !== 'cost' && keyFigures !== 'recycling'"
                                            [kfRegistration]="kfRegistration"
                                            [kfRegistrationDetail]="kfRegistrationDetail"
                                            [categories]="categories">
      </app-kf-registration-validation-table>
      <app-kf-registration-cost-validation-table *ngIf="keyFigures === 'cost' && kfRegistrationDetail"
                                                 [kfRegistration]="kfRegistration"
                                                 [kfRegistrationDetail]="kfRegistrationDetail"
                                                 [categories]="categories">
      </app-kf-registration-cost-validation-table>
      <app-kf-registration-recycling-validation-table *ngIf="keyFigures === 'recycling'"
                                                      [kfRegistration]="kfRegistration"
                                                      [kfRegistrationDetail]="kfRegistrationDetail"
                                                      [categories]="categories">
      </app-kf-registration-recycling-validation-table>
    </div>


    <div class="buttons-container align-right">
      <button mat-raised-button type="button"
              (click)="!kfRegistrationDetail?.kfRegistration?.completionStatus ? '' : reopen()"
              [disabled]="!kfRegistrationDetail?.kfRegistration?.completionStatus">
        <mat-icon class="material-icons-outlined">lock_open</mat-icon>
        <span> Reopen</span>
      </button>
      <button mat-raised-button color="primary" type="button"
              (click)="(!kfRegistrationDetail?.kfRegistration?.completionStatus
                  || kfRegistrationDetail?.kfRegistration?.validationStatus
                  || kfRegistrationDetail?.kfRegistration?.notValidable) ? '' : validate()"
              [disabled]="!kfRegistrationDetail?.kfRegistration?.completionStatus
                  || kfRegistrationDetail?.kfRegistration?.validationStatus
                  || kfRegistrationDetail?.kfRegistration?.notValidable">
        <mat-icon class="material-icons-outlined">check_circle</mat-icon>
        <span> Validate</span>
      </button>
      <button mat-raised-button color="warn" type="button"
              (click)="(!kfRegistrationDetail?.kfRegistration?.completionStatus
                  || kfRegistrationDetail?.kfRegistration?.validationStatus
                  || kfRegistrationDetail?.kfRegistration?.notValidable) ? '' : markNotValidable()"
              [disabled]="!kfRegistrationDetail?.kfRegistration?.completionStatus
                  || kfRegistrationDetail?.kfRegistration?.validationStatus
                  || kfRegistrationDetail?.kfRegistration?.notValidable">
        <mat-icon class="material-icons-outlined">not_interested</mat-icon>
        <span> Not able to validate</span>
      </button>
    </div>
  </mat-card-content>

</mat-card>
